import type { UpdatePartnershipCommandData } from '@festina/legalentity-general-types/legalentity'
import { typeUtils } from '@festina-life/core'
import { FormikForm, FormikSelect } from '@festina-life/ui/formikForms'
import { useTranslate, useTranslateEnum } from '@festina-life/ui/hooks'
import * as Yup from 'yup'

import { useHook, useService } from '../../lenteHooks'
import type { CommandDataFormProps } from '../commandActions/CommandDataFormAndSimulation'
import { PartnershipFormFields } from './PartnershipFormFields'

const validateKey = typeUtils.createValidator<UpdatePartnershipCommandData>()

export const UpdatePartnershipCommandDataForm = (
  props: CommandDataFormProps<UpdatePartnershipCommandData>,
) => {
  const translate = useTranslate()
  const translateEnum = useTranslateEnum()

  const cleanupInformationSource = useService(
    'logic.legalEntity.cleanupInformationSource',
  )

  const informationSources = useHook('pages.crm.useCrmInformationSources')()

  const { tenantId, ownerId } = useHook('routing.general.useEntityParams')()
  const { data: personVersion } = useHook(
    'fetchers.crm.useFetchPersonVersionLatest',
  )({
    tenantId,
    personId: ownerId,
  })
  const partnership = personVersion?.partnershipVersion

  return (
    <FormikForm
      initialValues={cleanupInformationSource({
        _type: 'UpdatePartnershipCommandData',
        partnership: {
          ...partnership,
          _type: 'Partnership',
          partnerName: {
            ...partnership?.partnerName,
            _type: 'PersonEntityName',
          },
        },
      })}
      {...props}
      validationSchema={Yup.object().shape({
        partnership: Yup.object({
          partnerPersonId: Yup.string().required(),
        }),
      })}
    >
      <PartnershipFormFields fieldNamePrefix={validateKey('partnership')}>
        <FormikSelect
          name={validateKey('informationSource')}
          label={translate('card.field.informationSource')}
          options={informationSources}
          renderFn={(x) =>
            translateEnum('legalEntity.enum.InformationSource', x)
          }
        />
      </PartnershipFormFields>
    </FormikForm>
  )
}
